import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs/internal/Observable';
import { ManualCreationCargoService } from 'src/app/modules/cargo/manual-creation-cargo/manual-creation-cargo.service';
import { AuthService } from '../services/authentication.service';
import { RoleService } from '../services/role.service';
import { StorageService } from '../services/storage.service';

@Injectable({ providedIn: 'root' })
export class GpsTypeResolver implements Resolve<any> {

    constructor(
        private authService: AuthService,
        private router: Router,
        private roleService: RoleService
    ) { }

    resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<any> | Promise<any> | any {
        if (this.authService && this.authService.getGPS().length) {
            return this.authService.getGPS();
        } else {
            if ((StorageService.checkStorage().getItem('_email') || sessionStorage.getItem('_email')) && this.authService) {
                return this.authService.getAllTypesGps();
            } else {
                return null;
            }
        }
    }

}
